/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "parts/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/1.jpg";
import team2 from "assets/images/2.jpg";
import team3 from "assets/images/3.jpg";
import team4 from "assets/images/4.jpg";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="info"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
            Why Choose Our Product Design Services?
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
  Whether you’re bringing a new idea to life or enhancing an existing product, our product design process ensures every decision is data-driven, every prototype is rigorously tested, and every interaction is crafted to deliver an exceptional user experience.

  Contact us today to explore how our product design services can help you create innovative, user-centered solutions that inspire and drive success.
</MKTypography>

          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="User-Centered Approach"
                position={{ color: "info", label: "user-friendly" }}
                description="We prioritize your users' needs at every stage of the design process to create products that resonate with them."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="End-to-End Design"
                position={{ color: "info", label: "threat detection" }}
                description="From research and ideation to prototyping and testing, we provide comprehensive design services to bring your product vision to life."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Collaboration & Transparency"
                position={{ color: "info", label: "specific business goals" }}
                description="We work closely with you throughout the design process to ensure the final product aligns with your goals and vision."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Continuous Improvement"
                position={{ color: "info", label: "maximize ROI" }}
                description="Our iterative approach to design and testing ensures that your product evolves with user feedback and market demands."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
